import { mapGetters } from "vuex";
import { stringHelper } from "@/components/mixins/stringHelper"

import { LiftLinkFormType, ILiftLinkForm } from "../../../Types";
import { props } from "@/components/Elements/PostalAddress";
import { LiftLinkService } from "@/services/LiftLinkService";

export default {
  props: {
    formData: {
      type: ILiftLinkForm,
      required: false
    },
    liftLinkConfiguration: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      DealerContactEmail: "",
      CustomerEmail: "",
      CustomerName: "",
      selectedSubscriptionOption: "",
      additionalComments: "",
      liftLinkFormType: LiftLinkFormType.AddOnForm,
      customerContactName: "",
      customerPhoneNumber: "",
      dealerSalesRepEmail: "",
      billingContactEmail: "",
      billingSubscriptionOption: '',
      billingSubscriptionOptions: [
        'Dealer',
        'Customer',
      ],
    };
  },
  mixins: [stringHelper],
  computed: {
    ...mapGetters(["user", "getContentItem"]),
 
    isFormValid() {
      return this.DealerContactEmail !== "" 
      && this.isEmailValid(this.DealerContactEmail)
      && this.CustomerName !== ""
      && this.isEmailValid(this.dealerSalesRepEmail)
      && (this.isEmailValid(this.billingContactEmail) || this.billingSubscriptionOption == "Dealer")
      && this.billingSubscriptionOption !== "";
    },
    showBillingContactEmail() {
      return this.billingSubscriptionOption === 'Customer';
    }
  },
  created() {
    this.DealerContactEmail = this.user.Email;
    if(this.formData) {
      this.DealerContactEmail = this.formData.DealerContactEmail;
      this.CustomerEmail = this.formData.CustomerEmail;
      this.CustomerName = this.formData.CustomerName;
      this.selectedSubscriptionOption = this.formData.selectedSubscriptionOption;
      this.additionalComments = this.formData.additionalComments;
      this.customerPhoneNumber = this.formData.customerPhoneNumber;
      this.customerContactName = this.formData.customerContactName;
      this.dealerSalesRepEmail = this.formData.dealerSalesRepEmail || "";
      this.billingContactEmail = this.formData.billingContactEmail || "";
      this.billingSubscriptionOption = this.formData.billingSubscriptionOption || '';
    }
    this.updateLiftLinkFormContext();
  },
  methods: {
    updateLiftLinkFormContext() {
      if (this.isFormValid) {
        const formData = {
          DealerContactEmail: this.DealerContactEmail,
          CustomerEmail: this.CustomerEmail,
          CustomerName: this.CustomerName,
          selectedSubscriptionOption: this.selectedSubscriptionOption,
          additionalComments: this.additionalComments,
          submissionType: this.liftLinkFormType,
          customerContactName: this.customerContactName,
          customerPhoneNumber: this.customerPhoneNumber,
          dealerSalesRepEmail: this.dealerSalesRepEmail,
          billingContactEmail: this.billingContactEmail,
          billingSubscriptionOption: this.billingSubscriptionOption
        };
        this.$emit("formSubmitted", formData);
      } else {
        this.$emit("formInvalid");
      }
    },
  },
};